/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import colors from 'shared-assets/lib/colors';

const ModalStyled = styled.section`
  position: fixed;
  overflow: auto;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(${colors.secondaryRGB.join(', ')}, 0.9);
  padding: 3rem 5rem;
  -webkit-overflow-scrolling: touch;

  .modalBody {
    max-width: 75vw;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    padding: 0;

    .modalBody {
      max-width: 100vw;
      margin: 0 auto;
    }
  }
`;

class Modal extends React.Component {
  componentDidMount() {
    document.getElementsByTagName('body')[0].classList.toggle('overflowHidden');
  }

  componentWillUnmount() {
    document.getElementsByTagName('body')[0].classList.toggle('overflowHidden');
  }

  render() {
    return (
      <ModalStyled
        onClick={e => {
          e.stopPropagation();
          this.props.onClickOutside();
        }}
        id="modal"
      >
        <div
          className="modalBody"
          role="dialog"
          style={this.props.modalStyle}
          onClick={e => {
            e.stopPropagation();
          }}
          data-testid="modal"
        >
          {this.props.children}
        </div>
      </ModalStyled>
    );
  }
}

Modal.defaultProps = {
  children: null,
  onClickOutside: () => {},
  modalStyle: null,
};

Modal.propTypes = {
  onClickOutside: PropTypes.func,
  children: PropTypes.node,
  modalStyle: PropTypes.object,
};

export default Modal;
